module.exports = __webpack_public_path__ + "static/img/weixin.fd37d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qxr/weixin.png
// module id = A8sm
// module chunks = 51